module.exports = __webpack_public_path__ + "static/partner7-f37d7aa3ae07b058863a59e065a3e399.png";